<template>
  <div>
    <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-if="$vuetify.breakpoint.width <= 510" class="mobile-menu-trigger" @click="drawer = !drawer"
          v-bind="attrs" v-on="on">
          <img src="@/assets/e logo.svg" alt="Menu Icon" width="25" />
        </v-btn>
      </template>
      <span>Open Menu</span>
    </v-tooltip>
    <v-dialog v-model="logoutDialog" max-width="450">
      <v-card class="primary primaryText--text pa-4">
        <v-card-title class="headline pb-2">
          Are you sure you want to logout?
        </v-card-title>

        <v-card-text class="pt-0 pb-5">
          Your session will be closed, and you will be logged out.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="logoutDialog = false">Cancel</v-btn>
          <v-btn color="accent" dark @click="$emit('logout'); logoutDialog = false;">Yes, Logout</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-navigation-drawer :clipped="$vuetify.breakpoint.lgAndUp" v-model="drawer" :mini-variant="miniNav" app
      enable-resize-watcher persistent stateless class="primary responsive-navbar">
      <v-list dense>
        <v-list-tile avatar>
          <v-list-tile-avatar @click="miniNav = !miniNav">
            <img v-if="showIcon" src="../../assets/avatar/solarIcon.svg" alt="Solar">
            <img v-else src="../../assets/avatar/user.svg" alt="User">
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ name }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn icon @click.native.stop="miniNav = !miniNav">
              <v-icon>chevron_left</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider class="mt-1"></v-divider>
        <template v-for="(item, index) in items">
          <v-divider v-if="item.divider" :key="'A' + index"></v-divider>
          <v-tooltip color="bg" right v-else v-show="item.verify ? item.verify(getUserInfo('role')) : true"
            :key="'B' + index">
            <template v-slot:activator="{ on }">
              <v-list-tile v-on="on" :key="item.text" v-on:click="navSelectionHandler(item.component)">
                <v-list-tile-action>
                  <img :class="active[componentRoute(item.component)] ? 'active-nav' : 'menu-icons'"
                    :src="require(`./../../assets/navigation/${item.icon}.svg`)" :alt="item.icon" width="20" />
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ $t(item.text) }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
            <span class="tooltip-text__color">{{ $t(item.text) }}</span>
          </v-tooltip>
        </template>

      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations
} from 'vuex'
import menuList from '@/services/menu.js'
import {
  version
} from '../../../../package.json'

export default {
  props: {
    name: String
  },
  data() {
    return {
      version,
      drawer: true,
      items: [],
      active: {},
      currentWidth: 0,
      currentTab: '',
      logoutDialog: false
    }
  },
  created() {
    if (this.getGeneralState('showHomeDB')) {
      this.items = menuList.items
    } else {
      this.items = menuList.menuItems
    }
  },
  onResize(event) {
    this.currentWidth = window.innerWidth
    if (this.$vuetify.breakpoint.xs) {
      this.items = menuList.mobileItems
    } else if (this.$vuetify.breakpoint.mdAndUp) {
      this.items = menuList.items
    }
  },
  mounted() {
    // this.miniNav = this.mini
    this.$set(this.active, this.extractPath(this.$route), true)
  },
  computed: {
    ...mapGetters([
      'getUserInfo',
      'getRules',
      'getGeneralState',
    ]),
    isDark() {
      return this.getGeneralState('theme_dark')
    },
    showIcon() {
      return this.getUserInfo('email') === 'abijitsolar@enerman.in'
    },
    widthBoolean() {
      return this.currentWidth < 960
    },
    miniNav: {
      get() {
        return this.getGeneralState('miniNav')
      },
      set(value) {
        this.SET_MINI_NAV(value)
      }
    }
  },
  methods: {
    ...mapMutations([
      'SET_SELECTED_COMPONENT_MENU',
      'SET_MINI_NAV'
    ]),
    extractPath(routerObj) {
      if (routerObj.path === '/') {
        return '/home'
      }
      return routerObj.path
    },
    navSelectionHandler(component) {
      this.currentTab = component
      switch (component) {
        case 'home':
        case 'plantOverview':
        case 'sld':
        case 'inverter-status':
        case 'devices':
        case 'alert':
        case 'more':
        case 'admin':
          this.$router.push(this.componentRoute(component))
          break
        case 'support':
          this.supportSite()
          break
        case 'logout':
          this.logoutDialog = true;
          break
      }
    },
    supportSite: function () {
      window.open('https://support.enerman.in/portal/en/signin')
    },
    componentRoute(param) {
      try {
        if (param == 'admin' && this.getUserInfo('role') == 'super-admin') {
          return '/ics-admin'
        } else if (this.getRules('rule')) {
          if (Object.keys(this.getRules(['rule', 'access_config', `${param}`])).length > 0) {
            if (Object.keys(this.getRules(['rule', 'access_config', `${param}`, 'path'])).length > 0) {
              return this.getRules(['rule', 'access_config', `${param}`, 'path'])
            }
            return `/general/${param}`
          }
          return `/${param}`
        } else {
          return '/'
        }
      } catch (err) {
        return '/'
      }
    }
  },
  watch: {
    currentTab() {
      this.SET_SELECTED_COMPONENT_MENU(this.currentTab)
    },
    mini() {
      this.miniNav = this.mini
    },
    $route(to, from) {
      this.$set(this.active, this.extractPath(from), false)
      this.$set(this.active, this.extractPath(to), true)
    },
    '$vuetify.breakpoint.width'(newWidth) {
      this.drawer = newWidth > 510
      this.miniNav = !this.mini
    }
  }
}
</script>

<style>
.theme--light .tooltip-text__color {
  color: #000;
}

.active-nav {
  filter: invert(52%) sepia(92%) saturate(392%) hue-rotate(354deg) brightness(102%) contrast(92%);
}

.theme--light .menu-icons {
  filter: invert(48%) sepia(12%) saturate(463%) hue-rotate(179deg) brightness(98%) contrast(86%);
}

@media (max-width: 510px) {
  .mobile-menu-trigger {
    margin-top: 10px;
    left: 0;
    z-index: 1000;
    background-color: transparent !important;
    box-shadow: none !important;
    padding: 0px 10px !important;
    min-width: 0 !important;
    border: none !important;
  }

  .menu-icons,
  .active-nav {
    margin-right: 17px;
  }

  .responsive-navbar {
    width: 70px !important;
    padding-left: -10px !important;
  }
}
</style>
